// eslint-disable-next-line import/prefer-default-export
export const transform = (product) => ({
  ...product,
  updatedAt: new Date(product.updatedAt),
  createdAt: new Date(product.createdAt),
});
